import { render, staticRenderFns } from "./Headline.global.vue?vue&type=template&id=11fcf2fa&scoped=true&lang=pug&"
import script from "./Headline.global.vue?vue&type=script&lang=ts&"
export * from "./Headline.global.vue?vue&type=script&lang=ts&"
import style0 from "./Headline.global.vue?vue&type=style&index=0&id=11fcf2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fcf2fa",
  null
  
)

export default component.exports